import { useState } from "react";

export const useLocalStorage = (key, initialValue) => {
  const [localStorageData, setLocalStorageData] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (err) {
      console.error(err);
      return initialValue;
    }
  });

  const setValue = value => {
    try {
      const valueToStore =
        value instanceof Function ? value(localStorageData) : value;
      setLocalStorageData(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (err) {
      console.error(err);
    }
  };

  return [localStorageData, setValue];
};

export default useLocalStorage;